export const LAYOUT = {
  TOGGLE_SIDEBAR_DESKTOP: "TOGGLE_SIDEBAR_DESKTOP",
  TOGGLE_SIDEBAR_MOBILE: "TOGGLE_SIDEBAR_MOBILE",
  SET_SIDEBAR: "SET_SIDEBAR",
  SET_LOADING: "SET_LOADING"
}

export const AUTH = {
  AUTH_LOGIN: "AUTH_LOGIN",
  AUTH_LOGOUT: "AUTH_LOGOUT",
  AUTH_REFRESH_TOKEN: "AUTH_REFRESH_TOKEN",
  FETCH_AUTH: "FETCH_AUTH"
}

export const EMPLOYEE = {
  FETCH_EMPLOYEE: "FETCH_EMPLOYEE",
  SHOW_EMPLOYEE: "SHOW_EMPLOYEE",
  CREATE_EMPLOYEE: "CREATE_EMPLOYEE",
  UPDATE_EMPLOYEE: "UPDATE_EMPLOYEE",
  GET_EMPLOYEE: "GET_EMPLOYEE",
  GET_INFO_EMPLOYEE: "GET_INFO_EMPLOYEE",
  FETCH_EMPLOYEE_DAYS_OFF: "FETCH_EMPLOYEE_DAYS_OFF",
  FETCH_DAYS_OFF_EXPORT: "FETCH_DAYS_OFF_EXPORT"
}

export const EMPLOYEE_SUMMER_TRIP = {
  GET_EMPLOYEE_SUMMER_TRIP: "GET_EMPLOYEE_SUMMER_TRIP",
  LIST_FLIGHT_DETAIL: "LIST_FLIGHT_DETAIL",
  GET_TEAM_NAMES: "GET_TEAM_NAMES",
  GET_SUMMER_TRIP_FOR_OVERVIEW: "GET_SUMMER_TRIP_FOR_OVERVIEW",
  GET_SUMMER_TRIP_MASTER_DETAIL: "GET_SUMMER_TRIP_MASTER_DETAIL",
  UPDATE_SUMMER_TRIP_MASTER: "UPDATE_SUMMER_TRIP_MASTER"
}

export const COMMONS = {
  FOOTS: "FOOTS",
  DIVISIONS: "DIVISIONS",
  POSITIONS: "POSITIONS",
  JOBTITLE: "JOBTITLE",
  WORKTYPE: "WORKTYPE",
  WORKSHIFT: "WORKSHIFT",
  COMPANIES: "COMPANIES",
  PROJECTS: "PROJECTS",
  LEVELS: "LEVELS",
  CERTIFICATES: "CERTIFICATES",
  DEVELOP_DIVISIONS: "DEVELOP_DIVISIONS",
  PARENT_DEVELOP_DIVISIONS: "PARENT_DEVELOP_DIVISIONS",
  QUALITY_DIVISIONS: "QUALITY_DIVISIONS",
  CONTRACTS: "CONTRACTS",
  MUST_SUBMIT: "MUST_SUBMIT",
  SKILL_LV2: "SKILL_LV2",
  FOOT_DIVISION: 'FOOT_DIVISION'
}

export const CHART = {
  MEMBER_COMPANIES: "MEMBER_COMPANIES",
  MEMBER_FOOTS: "MEMBER_FOOTS",
  MEMBER_DIVISIONS: "MEMBER_DIVISIONS",
  MEMBER_JOB_TITLE: "MEMBER_JOB_TITLE",
  MEMBER_IN_OUT: "MEMBER_IN_OUT"
}

export const SET_LOCALE = "SET_LOCALE"

export const CUSTOMER = {
  FETCH_CUSTOMER: "FETCH_CUSTOMER",
  DETAIL_CUSTOMER: "DETAIL_CUSTOMER",
  EDIT_CUSTOMER: "EDIT_CUSTOMER",
  UPDATE_CUSTOMER: "UPDATE_CUSTOMER",
  CREATE_CUSTOMER: "CREATE_CUSTOMER"
}

export const PROJECT = {
  FETCH_PROJECT: "FETCH_PROJECT",
  PROJECT_DETAIL: "PROJECT_DETAIL",
  GET_EMPLOYEE: "GET_EMPLOYEE",
  EMPLOYEES: "EMPLOYEES",
  CUSTOMERS: "CUSTOMERS",
  EMPLOYEE_POSITION: "EMPLOYEE_POSITION",
  GET_DETAIL_PROJECT: "GET_DETAIL_PROJECT",
  PROJECT_STATUS: "PROJECT_STATUS",
  FETCH_RESOURCE_SITUATION: "FETCH_RESOURCE_SITUATION",
  RESOURCE_SITUATION_CHART: "RESOURCE_SITUATION_CHART",
  GET_EMPLOYEE_SKILL: "GET_EMPLOYEE_SKILL",
  SET_LIST_KICK_OFF_BONUS: "SET_LIST_KICK_OFF_BONUS",
  SET_LIST_PROJECT_MEMBER: "SET_LIST_PROJECT_MEMBER",
  SET_KICK_OFF_BONUS_INFO: "SET_KICK_OFF_BONUS_INFO",
  SET_REVIEWS: "SET_REVIEWS",
  SET_CONTRACT_HISTORY: "SET_CONTRACT_HISTORY",
  TOTAL_RESOURCE_SITUATIONS: "TOTAL_RESOURCE_SITUATIONS",
  SET_RESOURCE_STATISTICS: "SET_RESOURCE_STATISTICS",
  GET_RESOURCE_STATISTICS: "GET_RESOURCE_STATISTICS",
  SET_RESOURCE_DIVISION_STATISTICS: "SET_RESOURCE_DIVISION_STATISTICS",
  SET_RESOURCE_SE_STATISTICS: "SET_RESOURCE_SE_STATISTICS",
  SET_RESOURCE_EFFORT_STATISTICS: "SET_RESOURCE_EFFORT_STATISTICS",
  SET_RESOURCE_START_END_DATE: "SET_RESOURCE_START_END_DATE",
  SET_PROJECT_STATUS_STATISTICS: "SET_PROJECT_STATUS_STATISTICS",
  SET_PROJECT_STATUS_TOOLTIP_STATISTICS: "SET_PROJECT_STATUS_TOOLTIP_STATISTICS",
  SET_PROJECT_OVERVIEW_AMOUNT: "SET_PROJECT_OVERVIEW_AMOUNT",
  SET_PERSON_CHARGE_PROJECTS: "SET_PERSON_CHARGE_PROJECTS",
  SET_PERSON_IN_CHARGE_MANMONTH: "SET_PERSON_IN_CHARGE_MANMONTH",
  SET_DATA_MM: "SET_DATA_MM",
}

export const TIMESHEET = {
  FETCH_TIMESHEET: "FETCH_TIMESHEET",
  DETAIL_TIMESHEET: "DETAIL_TIMESHEET",
  FETCH_TIMESHEET_REQUEST: "FETCH_TIMESHEET_REQUEST",
  FETCH_TIMESHEET_EXPORT: "FETCH_TIMESHEET_EXPORT",
  FETCH_TIMESHEET_EXPORT_LIST_SUBMIT: "FETCH_TIMESHEET_EXPORT_LIST_SUBMIT",
  FETCH_TIMESHEET_TODAY: "FETCH_TIMESHEET_TODAY",
  FETCH_TIMESHEET_SUMMARY: "FETCH_TIMESHEET_SUMMARY",
  FETCH_TIMESHEET_SUMMARY_EXPORT: "FETCH_TIMESHEET_SUMMARY_EXPORT",
  FETCH_TIMESHEET_SUBMIT: "FETCH_TIMESHEET_SUBMIT",
  FETCH_TIMESHEET_SUBMIT_HISTORY: "FETCH_TIMESHEET_SUBMIT_HISTORY",
  FETCH_TIMESHEET_SUBMIT_UNSUBMIT: "FETCH_TIMESHEET_SUBMIT_UNSUBMIT",
  FETCH_REMIND_HISTORY_LIST: "FETCH_REMIND_HISTORY_LIST",
  FETCH_EMPLOYEE_REMIND_HISTORY_LIST: "FETCH_EMPLOYEE_REMIND_HISTORY_LIST",
  FETCH_EMPLOYEE_TOTAL_REQUEST: "FETCH_EMPLOYEE_TOTAL_REQUEST",
  FETCH_EMPLOYEE_TIMESHEET_DETAIL: "FETCH_EMPLOYEE_TIMESHEET_DETAIL",
  FETCH_EMPLOYEE_TIMESHEET_SUMMARY: "FETCH_EMPLOYEE_TIMESHEET_SUMMARY",
}

export const OVERTIME_REQUEST = {
  FETCH_OVERTIME_REQUEST: "FETCH_OVERTIME_REQUEST",
  FETCH_OVERTIME_REQUEST_EXPORT: "FETCH_OVERTIME_REQUEST_EXPORT",
  SHOW_OVERTIME_REQUEST: "SHOW_OVERTIME_REQUEST",
  COMMON_PROJECT: "COMMON_PROJECT",
  FETCH_TOTAL_OVERTIME_REQUEST: "FETCH_TOTAL_OVERTIME_REQUEST"
}

export const REMOTE_REQUEST = {
  FETCH_REMOTE_REQUEST: "FETCH_REMOTE_REQUEST",
  FETCH_REMOTE_REQUEST_EXPORT: "FETCH_REMOTE_REQUEST_EXPORT",
  SHOW_REMOTE_REQUEST: "SHOW_REMOTE_REQUEST",
  COMMON_PROJECT: "COMMON_PROJECT",
  FETCH_TOTAL_REMOTE_REQUEST: "FETCH_TOTAL_REMOTE_REQUEST"
}

export const ACCOUNT = {
  FETCH_ACCOUNT: "FETCH_ACCOUNT"
}

export const SABBATICAL_LEAVE_REQUEST = {
  FETCH_SABBATICAL_LEAVE_REQUEST: "FETCH_SABBATICAL_LEAVE_REQUEST",
  DETAIL_SABBATICAL_LEAVE_REQUEST: "DETAIL_SABBATICAL_LEAVE_REQUEST",
  COMMON_REASONS: "COMMON_REASONS",
  FETCH_TOTAL_SABBATICAL_LEAVE_REQUEST: "FETCH_TOTAL_SABBATICAL_LEAVE_REQUEST",
  LIST_SABBATICAL_REQUEST_ALL_APPROVAL: "LIST_SABBATICAL_REQUEST_ALL_APPROVAL",
  GET_EXPIRE_SABBATICAL_LOG: "GET_EXPIRE_SABBATICAL_LOG",
  GET_EXPIRE_SABBATICAL_LEAVE: "GET_EXPIRE_SABBATICAL_LEAVE",
  GET_EXPIRE_SABBATICAL: "GET_EXPIRE_SABBATICAL"
}

export const ADDITIONAL_TIMESHEET = {
  SHOW_ADDITIONAL_TIMESHEET: "SHOW_ADDITIONAL_TIMESHEET",
  FETCH_ADDITIONAL_TIMESHEET: "FETCH_ADDITIONAL_TIMESHEET",
  FETCH_TOTAL_ADDITIONAL_TIMESHEET_REQUEST: "FETCH_TOTAL_ADDITIONAL_TIMESHEET_REQUEST"
}

export const SHORT_LEAVE_REQUEST = {
  FETCH_SHORT_LEAVE_REQUEST: "FETCH_SHORT_LEAVE_REQUEST",
  SET_PAGINATION: "SET_PAGINATION",
  FETCH_SHORT_LEAVE_REQUEST_EXPORT: "FETCH_SHORT_LEAVE_REQUEST_EXPORT",
  SET_ASSIGNABLE_EMPLOYEES: "SET_ASSIGNABLE_EMPLOYEES"
}

export const CONTRACT_EMPLOYEE = {
  EMPLOYEES: "EMPLOYEES",
  CONTRACTS: "CONTRACTS",
  GET_INFO_EMPLOYEE_CONTRACT: "GET_INFO_EMPLOYEE_CONTRACT",
  FETCH_CONTRACT_EMPLOYEE_REQUEST: "FETCH_CONTRACT_EMPLOYEE_REQUEST"
}

export const SKILL_SHEET = {
  SKILL_SHEET: "SKILL_SHEET",
  SHOW_SKILL_SHEET: "SHOW_SKILL_SHEET"
}

export const SABBATICAL_COMPENSATE_REQUEST = {
  FETCH_SABBATICAL_COMPENSATE_REQUEST: "FETCH_SABBATICAL_COMPENSATE_REQUEST",
  DETAIL_SABBATICAL_COMPENSATE_REQUEST: "DETAIL_SABBATICAL_COMPENSATE_REQUEST"
}

export const EMPLOYEE_LEVEL = {
  LIST_EMPLOYEE_LEVEL: "LIST_EMPLOYEE_LEVEL",
  DELETE_EMPLOYEE_LEVEL: "DELETE_EMPLOYEE_LEVEL",
  CREATE_EMPLOYEE_LEVEL: "CREATE_EMPLOYEE_LEVEL",
  UPDATE_EMPLOYEE_LEVEL: "UPDATE_EMPLOYEE_LEVEL"
}

export const HOLIDAY_SETTING = {
  LIST_HOLIDAY_SETTING: "LIST_HOLIDAY_SETTING",
  SET_WORK_TIMES: "SET_WORK_TIMES"
}

export const SEAT_EMPLOYEE = {
  LIST_SEAT_EMPLOYEE: "LIST_SEAT_EMPLOYEE",
  CREATE_SEAT_EMPLOYEE: "CREATE_SEAT_EMPLOYEE",
  UPDATE_SEAT_EMPLOYEE: "UPDATE_SEAT_EMPLOYEE",
  DELETE_SEAT_EMPLOYEE: "DELETE_SEAT_EMPLOYEE",
  GET_EMPLOYEE_SEAT: "GET_EMPLOYEE_SEAT",
  GET_STAFF_SEAT: "GET_STAFF_SEAT",
}
export const TYPE_WORK = {
  LIST_TYPE_WORK_EMPLOYEE: "LIST_TYPE_WORK_EMPLOYEE",
  UPDATE_TYPE_WORK_EMPLOYEE: "UPDATE_TYPE_WORK_EMPLOYEE",
  PROJECT_REMOTE: "PROJECT_REMOTE",
}

//dashboard
export const DASHBOARD = {
  SET_EMPLOYEEES: "SET_EMPLOYEEES",
  SET_DIVISIONS: "SET_DIVISIONS",
  SET_EMPLOYEEES_SENIORITY: "SET_EMPLOYEEES_SENIORITY",
  SET_EMPLOYEE_BY_GRADE: "SET_EMPLOYEE_BY_GRADE",
  GET_FLUCTUATING_SENIORITY: "GET_FLUCTUATING_SENIORITY"
}
